import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="relative overflow-hidden py-[60px] px-5 md:py-[80px] md:px-5 hero-grain" style={{
    background: 'linear-gradient(160deg, #2B4A42 0%, #1C352C 60%, #0E1F1A 100%)'
  }} data-id="element-96">
      {/* Gold decorative circle */}
      <div className="absolute -top-[100px] -right-[150px] w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(201, 168, 76, 0.12), transparent 70%)'
    }} data-id="element-97" />

      <div className="max-w-[1000px] mx-auto relative z-10" data-id="element-98">
        <div className="flex flex-col-reverse md:flex-row md:items-center md:gap-12 mb-10" data-id="element-99">
          {/* Left side: Text Content */}
          <div className="flex-1 text-center md:text-left mt-8 md:mt-0" data-id="element-100">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 border border-oro/40 bg-oro/15 text-oro py-2 px-[18px] rounded-full text-[0.8rem] font-semibold tracking-[1.5px] uppercase mb-7 animate-fade-in-down" data-id="element-101">
              <span className="animate-blink" data-id="element-102">●</span>
              Protocolo de Rescate Metabólico · Edición 2025
            </div>

            {/* Headline */}
            <h1 className="font-display font-black text-white leading-[1.2] mb-5 animate-fade-in-up-delay-1" style={{
            fontSize: 'clamp(2rem, 5vw, 3.2rem)'
          }} data-id="element-103">
              La Hormona Que Está
              <br data-id="element-104" />
              <span className="text-oro relative inline-block" data-id="element-105">
                Engordando Tu Abdomen
                <span className="absolute bottom-[-4px] left-0 w-full h-[3px] bg-oro rounded-sm animate-expand-line origin-left" data-id="element-106" />
              </span>
              <br data-id="element-107" />
              Después de los 45
            </h1>

            {/* Subheadline */}
            <p className="text-white/80 max-w-[680px] mx-auto md:mx-0 font-normal animate-fade-in-up-delay-2" style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.25rem)'
          }} data-id="element-108">
              Cómo{' '}
              <strong className="text-white font-semibold" data-id="element-109">
                apagar el cortisol
              </strong>
              , reactivar tu metabolismo y eliminar la grasa abdominal rebelde
              naturalmente — sin dietas de hambre, sin cardio extremo, en solo
              10 minutos al día.
            </p>
          </div>

          {/* Right side: Cover Image */}
          <div className="flex-1 flex justify-center md:justify-end animate-fade-in-up" data-id="element-110">
            <div className="relative w-full max-w-[220px] md:max-w-[280px] rounded-xl overflow-hidden transition-transform duration-500 ease-out hover:!transform-none" style={{
            boxShadow: '0 25px 60px rgba(0,0,0,0.4)',
            transform: 'perspective(1200px) rotateY(-4deg)',
            border: '1px solid rgba(201, 168, 76, 0.2)'
          }} data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/wQk2gYsXiJ3e7iWGG38ZnZ/ChatGPT_Image_14_mar_2026,_04_43_55_p.m..png" alt="La Hormona Que Está Engordando Tu Abdomen Después de los 45" className="w-full h-auto block" data-id="element-112" />
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="animate-fade-in-up-delay-3" data-id="element-113">
          <CountdownTimer data-id="element-114" />
        </div>

        {/* CTA Area */}
        <div className="animate-fade-in-up-delay-3 text-center mt-8" data-id="element-115">
          {/* Price tag */}
          <div className="inline-flex items-center justify-center gap-3 mb-4" data-id="element-116">
            <span className="text-base text-white/50 line-through font-medium" data-id="element-117">
              Valor real: $47.00
            </span>
            <span className="text-[2rem] font-bold text-oro font-display" data-id="element-118">
              $6.36
            </span>
            <span className="bg-rojo-urgencia text-white text-[0.7rem] font-bold py-1 px-2.5 rounded-full uppercase tracking-wider" data-id="element-119">
              -87% HOY
            </span>
          </div>

          {/* CTA Button */}
          <div className="flex justify-center" data-id="element-120">
            <CtaButton href="#oferta" ariaLabel="Obtener el Protocolo ahora por $6.36" data-id="element-121">
              Sí, Quiero Mi Protocolo por $6.36
            </CtaButton>
          </div>

          {/* Security badges */}
          <div className="flex items-center justify-center gap-5 mt-4 flex-wrap" data-id="element-122">
            <span className="flex items-center gap-1.5 text-white/65 text-[0.78rem] font-medium" data-id="element-123">
              <span className="text-[0.9rem]" data-id="element-124">🔒</span>
              Pago 100% Seguro
            </span>
            <span className="flex items-center gap-1.5 text-white/65 text-[0.78rem] font-medium" data-id="element-125">
              <span className="text-[0.9rem]" data-id="element-126">📱</span>
              Acceso Inmediato
            </span>
            <span className="flex items-center gap-1.5 text-white/65 text-[0.78rem] font-medium" data-id="element-127">
              <span className="text-[0.9rem]" data-id="element-128">↩️</span>
              Garantía de 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}